import React from 'react';
import { Link } from 'react-router-dom';
type ButtonProps = {
  children: React.ReactNode;
  to?: string;
  href?: string;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  onClick?: () => void;
  type?: 'button' | 'submit' | 'reset';
};
const Button = ({
  children,
  to,
  href,
  variant = 'primary',
  size = 'md',
  className = '',
  onClick,
  type = 'button'
}: ButtonProps) => {
  const baseStyles = 'inline-flex items-center justify-center font-medium transition-all duration-300 rounded focus:outline-none transform hover:scale-105';
  const variants = {
    primary: 'bg-[#95c11f] hover:bg-[#7ba318] text-[#1a2e1a] shadow-md hover:shadow-lg',
    secondary: 'bg-[#1a2e1a] hover:bg-[#263f26] text-white shadow-md hover:shadow-lg',
    outline: 'border-2 border-[#95c11f] text-[#95c11f] hover:bg-[#95c11f] hover:text-[#1a2e1a]'
  };
  const sizes = {
    sm: 'text-sm py-2 px-4',
    md: 'text-base py-2.5 px-6',
    lg: 'text-lg py-3 px-8'
  };
  const buttonClasses = `${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`;
  if (to) {
    return <Link to={to} className={buttonClasses} data-id="element-144">
        {children}
      </Link>;
  }
  if (href) {
    return <a href={href} className={buttonClasses} target="_blank" rel="noopener noreferrer" data-id="element-145">
        {children}
      </a>;
  }
  return <button type={type} className={buttonClasses} onClick={onClick} data-id="element-146">
      {children}
    </button>;
};
export default Button;